<div
  #captionContainerElRef
  class="inner"
	[ngClass]="{
		'noBorderRadiusRight': isContentOverflowing(),
		'inner--hidden': !feedbackItem
	}">
  @if (feedbackItem) {
    <div class="comment-caption">
      <span>
        <strong class="comment-creator-name">
          {{ feedbackItem.fullname }}
          @if (feedbackItem.was_ai_generated && featureFlagService.isAvailable('ECHOREFLECT_REBRAND')) {
            <i class="ficon-sparkles-solid" aria-hidden="true"></i>
          }
        </strong>
        @for (tag of feedbackItem.markers; track tag) {
          <span class="comment-tag">
            <marker [marker]="tag" [aiStyle]="feedbackItem.was_ai_generated"></marker>
          </span>
        }
        <span class="comment-caption-text" [innerHTML]="feedbackItem.text | sanitize"></span>
        @if (feedbackItem.media.length) {
          <span translate="feedback-session-comment-captions_media-comment"></span>
        }
      </span>
    </div>
  }
</div>
